// src/components/screens/HomeScreen.jsx
import React from 'react';
import { 
  Leaf, Calendar, CheckCircle, Award, Cloud, 
  Sun, MessageSquare, MapPin, Camera, ToggleLeft, 
  ChevronRight 
} from 'lucide-react';
import StatusCard from '../common/StatusCard';
import ProductCard from '../common/ProductCard';
import QuickService from '../common/QuickService';
import recomendedProducts from '../../dados/recomendedProducts';
import {saveProduct} from '../../store/useProduct';

const HomeScreen = ({ setActiveScreen }) => {
  const userName = sessionStorage.getItem("userName") || "João";

  function handleProductClick(product) {
    saveProduct(product)
    setActiveScreen('product')
  }

  return (
  <div className="p-4">
    <h2 className="text-2xl font-bold mb-6 text-gray-800">Olá, {userName}!</h2>
    
    {/* Banner principal */}
    <div className="bg-gradient-to-r from-[#068cb0] to-[#033f4f] rounded-xl p-5 shadow-md mb-6">
      <div className="flex items-center">
        <div className="flex-1">
          <h3 className="text-white text-lg font-semibold mb-1">Seu jardim está incrível!</h3>
          <p className="text-green-100 text-sm">Próxima manutenção em 3 dias</p>
          <button className="mt-3 bg-white text-green-600 px-3 py-1 rounded-lg text-sm font-medium" onClick={() => {setActiveScreen('agenda')}}>
            Ver agenda
          </button>
        </div>
        <div className="w-20 h-20 bg-[#028090] rounded-xl flex items-center justify-center">
          <Leaf size={40} className="text-white" />
        </div>
      </div>
    </div>
    
    {/* Resumo de serviços */}
    <div className="flex space-x-3 mb-6 overflow-x-auto pb-2">
      <StatusCard 
        icon={<Calendar className="text-blue-500" />} 
        title="Próxima Visita" 
        value="06/04"
        color="bg-blue-50" 
      />
      <StatusCard 
        icon={<CheckCircle className="text-green-500" />} 
        title="Serviços" 
        value="2 este mês"
        color="bg-green-50" 
      />
      <StatusCard 
        icon={<Award className="text-yellow-500" />} 
        title="Pontos" 
        value="350"
        color="bg-yellow-50" 
      />
    </div>
    
    {/* Loja com produtos recomendados */}
    <div className="mb-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-800">Produtos Recomendados</h3>
        <button className="text-green-600 text-sm font-medium flex items-center" onClick={() => setActiveScreen('shop')}>
          Ver todos
          <ChevronRight size={16} />
        </button>
      </div>
      
      <div className="flex space-x-3 overflow-x-auto pb-2">
        {
          recomendedProducts.map((product, index) => (
            <ProductCard
              key={index}
              image={product.image} 
              title={product.title} 
              description={product.description} 
              price={product.price} 
              discount={product.discount} 
              rating={product.rating} 
              icon={product.icon}
              onClick={() => handleProductClick(product)}
            />
          ))
        }
      </div>
    </div>
    
    {/* Dicas de cuidado */}
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Dicas para Seu Jardim</h3>
      
      <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-4 shadow-sm mb-3 border border-blue-200">
        <div className="flex">
          <div className="w-12 h-12 bg-blue-200 rounded-lg flex items-center justify-center mr-3">
            <Cloud className="text-blue-600" size={24} />
          </div>
          <div>
            <p className="font-semibold text-blue-800">Alerta de Chuva</p>
            <p className="text-sm text-blue-700">Previsão para amanhã. Recomendamos adiar a rega programada.</p>
          </div>
        </div>
        <div className="mt-2 flex justify-end">
          <button className="text-blue-700 text-sm font-medium bg-blue-200 rounded-lg px-3 py-1">
            Ajustar rega
          </button>
        </div>
      </div>
      
      <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 rounded-xl p-4 shadow-sm border border-yellow-200">
        <div className="flex">
          <div className="w-12 h-12 bg-yellow-200 rounded-lg flex items-center justify-center mr-3">
            <Sun className="text-yellow-600" size={24} />
          </div>
          <div>
            <p className="font-semibold text-yellow-800">Calor Intenso</p>
            <p className="text-sm text-yellow-700">Aumente a frequência de rega para plantas em vasos nos próximos dias.</p>
          </div>
        </div>
        <div className="mt-2 flex justify-end">
          <button className="text-yellow-700 text-sm font-medium bg-yellow-200 rounded-lg px-3 py-1">
            Ver mais dicas
          </button>
        </div>
      </div>
    </div>
    
    {/* Serviços rápidos */}
    <div>
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Serviços Rápidos</h3>
      
      <div className="grid grid-cols-4 gap-3">
        <QuickService 
          icon={<MessageSquare className="text-purple-500" />} 
          text="Chat"
          color="bg-purple-50"
          onClick={() => setActiveScreen('chat')}
        />
        <QuickService 
          icon={<MapPin className="text-red-500" />} 
          text="Rastrear"
          color="bg-red-50"
          onClick={() => setActiveScreen('rastrear')}
        />
        <QuickService 
          icon={<Camera className="text-blue-500" />} 
          text="Câmeras"
          color="bg-blue-50"
          onClick={() => setActiveScreen('cameras')}
        />
        <QuickService 
          icon={<ToggleLeft className="text-green-500" />} 
          text="Automação"
          color="bg-green-50"
          onClick={() => setActiveScreen('automation')}
        />
      </div>
    </div>
  </div>
)};

export default HomeScreen;